var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandCommunication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3621_167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55656 15.9774L12 14.8371L14.4434 15.9774L14.1041 13.3032L15.9502 11.3348L13.3032 10.8326L12 8.47059L10.6968 10.8326L8.04977 11.3348L9.89593 13.3032L9.55656 15.9774ZM8.04977 7.181L12 0L15.9502 7.181L24 8.72851L18.3937 14.7014L19.4118 22.8326L12 19.3575L4.58823 22.8326L5.60633 14.7014L0 8.71493L8.04977 7.181Z",
    fill: "#B3A5DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3621_167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22.819,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandCommunication);
export default __webpack_public_path__ + "static/media/brand-communication.f620d5860835610525125c50201b7d67.svg";
export { ForwardRef as ReactComponent };